module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "public-top-layout"
  }, [_c('div', {
    staticClass: "topbar"
  }, [_c('div', {
    staticClass: "user-entry",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n      您好，欢迎来到\n      "), _c('router-link', {
    staticStyle: {
      "color": "#ec671a"
    },
    attrs: {
      "to": _vm.home,
      "title": "开心云商"
    }
  }, [_vm._v("开心云商")])], 1), _vm._v(" "), _c('div', {
    staticClass: "quick-menu"
  }, [(!_vm.name) ? _c('dl', {
    staticStyle: {
      "width": "100px"
    }
  }, [_c('dt', [_c('p', {
    staticClass: "menu-top"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/register'
      }
    }
  }, [_vm._v("注册")]), _c('span', {
    staticStyle: {
      "margin": "0 4px"
    }
  }, [_vm._v("/")]), _c('router-link', {
    attrs: {
      "to": {
        path: '/login'
      }
    }
  }, [_vm._v("登录")])], 1)])]) : _c('dl', {
    staticClass: "userMenuSty",
    staticStyle: {
      "width": "160px"
    }
  }, [_c('dt', {
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.$store.getters.face,
      "height": "120",
      "width": "120"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "menu-top",
    attrs: {
      "to": {
        path: '/member/member'
      }
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down"
  })], 1), _vm._v(" "), _c('dd', {
    staticClass: "userMenuStyChild",
    staticStyle: {
      "left": "40px"
    }
  }, [_c('ul', _vm._l((_vm.loginMenuList), function(child) {
    return _c('li', {
      key: _vm.name + child.name
    }, [(child.name !== '退出登录') ? _c('router-link', {
      attrs: {
        "to": child.route
      }
    }, [_vm._v(_vm._s(child.name))]) : _c('a', {
      on: {
        "click": _vm.exitSys
      }
    }, [_vm._v(_vm._s(child.name))])], 1)
  }), 0)])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.menuList), function(menu, index) {
    return _c('dl', {
      key: index,
      style: (index == 1 ? 'width:22px' : '')
    }, [_c('dt', {
      on: {
        "mouseenter": function($event) {
          return _vm.showChild(index)
        },
        "mouseleave": _vm.hideChild
      }
    }, [(menu.route) ? _c('router-link', {
      attrs: {
        "to": menu.route
      }
    }, [_vm._v(_vm._s(menu.name))]) : _c('p', {
      staticClass: "menu-top"
    }, [_vm._v(_vm._s(menu.name))])], 1), _vm._v(" "), (menu.children) ? _c('dd', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.hover),
        expression: "index === hover"
      }],
      on: {
        "mouseenter": function($event) {
          return _vm.showChild(index)
        },
        "mouseleave": _vm.hideChild
      }
    }, [_c('ul', _vm._l((menu.children), function(child) {
      return _c('li', {
        key: index + child.name
      }, [_c('router-link', {
        attrs: {
          "to": child.route
        }
      }, [_vm._v(_vm._s(child.name))])], 1)
    }), 0)]) : _vm._e(), _vm._v(" "), (index == 2) ? _c('dd', {
      on: {
        "mouseenter": function($event) {
          return _vm.showChild(index)
        },
        "mouseleave": _vm.hideChild
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showQr),
        expression: "showQr"
      }],
      staticClass: "margin-top"
    }, [_c('img', {
      attrs: {
        "data-v-4c94b89f": "",
        "src": require("../../../assets/images/guy-img.png"),
        "width": "80px",
        "height": "80px"
      }
    })])]) : _vm._e()])
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('dl', {
    staticClass: "userMenuSty"
  }, [_vm._m(2), _vm._v(" "), _c('dd', {
    staticClass: "userMenuStyChild"
  }, [_c('ul', {
    staticStyle: {
      "width": "160px"
    }
  }, [_c('li', [(_vm.storeShow) ? _c('a', {
    on: {
      "click": _vm.toStore
    }
  }, [_vm._v("商家中心")]) : _vm._e()]), _vm._v(" "), _c('li', [(!_vm.storeShow && _vm.isLogin) ? _c('a', {
    on: {
      "click": _vm.openShop
    }
  }, [_vm._v("免费开店")]) : _vm._e()]), _vm._v(" "), _c('li', [(_vm.marketShow) ? _c('a', {
    on: {
      "click": _vm.toPfList
    }
  }, [_vm._v("批发价商品")]) : _vm._e()]), _vm._v(" "), _c('li', [(_vm.isLogin && _vm.firstBuyShow) ? _c('a', {
    on: {
      "click": _vm.toStore
    }
  }, [_vm._v("云优品服务站")]) : _vm._e()]), _vm._v(" "), _c('li', [(_vm.isLogin && _vm.firstBuyShow) ? _c('a', {
    on: {
      "click": _vm.toFirstBuy
    }
  }, [_vm._v("\n                云优品店长采购平台\n              ")]) : _vm._e()]), _vm._v(" "), _c('li', [(_vm.isLogin && !_vm.firstBuyShow) ? _c('a', {
    on: {
      "click": _vm.openShop
    }
  }, [_vm._v("\n                申请服务站\n              ")]) : _vm._e()]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/createLeague'
      }
    }
  }, [_vm._v("联盟商家")])], 1)])])])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticStyle: {
      "width": "22px"
    }
  }, [_c('dt', [_vm._v("|")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticStyle: {
      "width": "22px"
    }
  }, [_c('dt', [_vm._v("|")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('p', {
    staticClass: "menu-top"
  }, [_vm._v("商家中心")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0890f15c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/layout/top-layout.vue
// module id = 1523
// module chunks = 1